import { render, staticRenderFns } from "./OnSuccessModal.vue?vue&type=template&id=676dd1cb&scoped=true"
import script from "./OnSuccessModal.vue?vue&type=script&lang=js"
export * from "./OnSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./OnSuccessModal.vue?vue&type=style&index=0&id=676dd1cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676dd1cb",
  null
  
)

export default component.exports